import React from 'react';
import Actions from 'components/DynamicTable/DynamicTableComponents/Editable/Actions';
import ActionEditIcon from 'resources/img/action-edit-icon.svg';
import ActionDeleteIcon from 'resources/img/action-delete-icon.svg';
import Switch from 'components/Switch';
import { ALERT_TYPES } from '@etiquette-ui/alert-dialog';

const RowActions = ({ item, state, globalState }) => {

  const actions = [
    {
      event: () => {
        globalState.config
          .alert({
            type: ALERT_TYPES.CONFIRM,
            config: {
              title: globalState.config.translate('Delete Email Template'),
              body: globalState.config.translate('Are you sure you want to delete this template?'),
              closeText: globalState.config.translate('Go Back'),
              submitText: globalState.config.translate('Delete'),
            },
          })
          .then(() => {
            globalState.config.dispatcher.deleteStart({ id: +item.id, groupId: globalState.config.groupId });
          })
          .catch(() => {});
      },
      src: ActionDeleteIcon,
    },
    {
      event: () => globalState.config.history.push(`templates/edit/${item.id}`),
      src: ActionEditIcon,
    },
    {
      child: <Switch active={item.isActive} onClick={()=>globalState.config.dispatcher.toggleActive({...item, isActive: !!item.isActive ? 0 : 1})} />,
    },
  ];

  return <Actions 
  loading={globalState.config.data.fetching?.config?.id===item.id} 
  actions={actions} 
  style={{alignItems: 'start', marginTop: '10px',}}
  />;
};

export default RowActions;
